export default "__VITE_ASSET__316c3969__"